export default __webpack_public_path__ + "static/media/home-bgm.1482dbc2.png";